<div class="thc-cbd-group-section {{partnerName}}">
    <ng-container *ngIf="IsVisibleForPartner && showRecommendations">
        <div class="info-text">Für die von ihnen ausgewählte Indikation liegen Empfehlungen zu der Cannabinoidkonzentration der Arzneimittel vor. Diese Empfehlungen* werden von internationalen Experten angeboten. Bitte wählen Sie aus, ob Sie diese angezeigt bekommen möchten. Derzeit stehen die folgenden Empfehlungen zur Auswahl zur Verfügung:</div>
        <div class="recommendation-button">
            <div class="recom-button" (click)="getRecommendation()">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.BETAHEALTH">
                        <img src="/images/private/betahealth/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.AVEXTRA">
                        <img src="/images/private/avextra/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.ALTHEA">
                        <img src="/images/private/althea/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.FOUR_20_PHARMA">
                        <img src="/images/private/420pharma/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <img src="/images/icons/Round Button.svg" alt="Round Button.svg" />
                    </ng-container>
                </ng-container>
                <div class="text">
                    <div>Cannabinoidkonzentration Empfehlung</div>
                    <span>basierend auf dem israelischen Green Book</span>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="recommendation-text" *ngIf="IsVisibleForPartner && recommendedTexts.length">
        <div class="title">Zu behandelnde Indikation (entsprechend Frage 1)</div>
        <div class="text" *ngFor="let recomm of recommendedTexts">{{recomm.Text}}</div>
    </div>
    <thc-cbd-cards [partnerName]="partnerName" [selectedGroup]="selectedGroup" [recommendedTexts]="recommendedTexts" (onSelectGroup)="selectGroup($event)"></thc-cbd-cards>
    <div class="thc-cbd-group-legend" *ngIf="IsVisibleForPartner && showLegend">
        <div class="thc-cbd-group-legend-rectangle"></div>
        <div class="thc-cbd-group-legend-text">Empfehlung, bitte bestätigen Sie durch Klicken Ihre Auswahl</div>
    </div>
    <div class="bottom-info-text" *ngIf="IsVisibleForPartner && showRecommendations">* Copeia übernimmt keine Verantwortung für die Vollständigkeit und Richtigkeit dieser Informationen.</div>
</div>
